const DEBOUNCE_MS = 50;

type UpdateSource = (doFit: boolean) => void;

type DebouncedUpdateSource = {
	(doFit: boolean): void;
	cancel: () => void;
};

export const useDebouncedUpdateSource = (updateSource: UpdateSource): DebouncedUpdateSource => {
	let debounceTimer: ReturnType<typeof setTimeout> | null = null;
	let pendingDoFit = false;

	const wrapper = (doFit: boolean): void => {
		pendingDoFit = pendingDoFit || doFit;
		if (debounceTimer != null) {
			clearTimeout(debounceTimer);
		}
		debounceTimer = setTimeout(() => {
			updateSource(pendingDoFit);
			pendingDoFit = false;
			debounceTimer = null;
		}, DEBOUNCE_MS);
	};

	const debouncedUpdateSource: DebouncedUpdateSource = Object.assign(wrapper, {
		cancel: (): void => {
			if (debounceTimer != null) {
				clearTimeout(debounceTimer);
			}
			debounceTimer = null;
		},
	});

	return debouncedUpdateSource;
};
